<div class="modal-header always-enabled" [ngClass]="{'border-bottom-0': data.noBorder}">
  <h4 class="modal-title" id="modal-title">
    @if (data.type !== 'primary') {
      @switch (data.type) {
        @default {
          <i class="fa-light fa-exclamation-triangle fa-fw me-1 text-danger" aria-hidden="true"></i>
        }
        @case ('warning') {
          <i class="fa-light fa-exclamation-triangle fa-fw me-1 text-warning" aria-hidden="true"></i>
        }
        @case ('info') {
          <i class="fa-light fa-exclamation-triangle fa-fw me-1 text-info" aria-hidden="true"></i>
        }
      }
    }
    {{ title }}
  </h4>
  <div class="btn-close-wrapper rounded-circle position-absolute end-0 me-3">
    <button type="button" class="btn-close m-0" aria-label="Close button" aria-describedby="modal-title"
            (click)="callback(null)"></button>
  </div>
</div>
<div class="modal-body" [ngClass]="{'px-3': data.alignHeaderBody}">
  @if (data.body) {
    <ng-container [ngTemplateOutlet]="data.body"></ng-container>
  } @else {
    @if (data.message) {
      <p>{{ data.message }}</p>
    }
    @for (messagePoint of messagePoints; track messagePoint) {
      <ul>
        <li [innerHTML]="messagePoint"></li>
      </ul>
    }
    @if (data.messageSeperated && messagePoints && messagePoints.length > 0) {
      <hr class="message-separator">
    }
    @if (data.beforePointsMessage) {
      <p>{{ data.beforePointsMessage }}</p>
    }
    @for (point of points; track point) {
      <ul>
        <li [innerHTML]="point"></li>
      </ul>
    }
    @if (data.afterPointsMessage) {
      <p>{{ data.afterPointsMessage }}</p>
    }
    @if (data.withReason) {
      <app-form-group [label]="reasonLabel">
        <input class="form-control" required placeholder="Enter reason" [(ngModel)]="data.reason">
      </app-form-group>
    }
    @if (data.withReasonTextArea) {
      <app-form-group [label]="reasonLabel" [omitLabel]="true">
        <textarea class="form-control" 
                  rows="4"
                  required
                  [placeholder]="reasonLabel"
                  [(ngModel)]="data.reason"
          ></textarea>
      </app-form-group>
    }
    @if (data.withChosableReason) {
      @if (data.chosableMessage) {
        <p>{{ data.chosableMessage }}</p>
      }
      @if (data.withChosableReason) {
        <app-form-group>
          <label for="for-radio">{{ reasonLabel }}</label>
          <app-radio
            [(ngModel)]="data.reason"
            [options]="data.chosableReasons"
            [formatter]="data.chosableReasonFormatter"
            id="for-radio"
            [inline]="true" required></app-radio>
        </app-form-group>
      }
    }
    @if (data.question) {
      <p>{{ data.question }}</p>
    }
  }
</div>
<div class="modal-footer" [ngClass]="{'border-top-0': data.noBorder}">
  <button type="button" class="btn btn-outline-secondary me-3" (click)="callback(false)">{{ cancelText }}</button>
  <!-- Button style -->
  @switch (data.type) {
    @default {
      <button type="button" [appAutoFocus]="true" [autoFocusInOverlay]="true" class="btn btn-danger"
              (click)="callback(true)">{{ confirmText }}
      </button>
    }
    @case ('warning') {
      <button type="button" [appAutoFocus]="true" [autoFocusInOverlay]="true"
              class="btn btn-warning" (click)="callback(true)">{{ confirmText }}
      </button>
    }
    @case ('info') {
      <button type="button" [appAutoFocus]="true" [autoFocusInOverlay]="true" class="btn btn-info"
              (click)="callback(true)">{{ confirmText }}
      </button>
    }
    @case ('primary') {
      <button type="button" [appAutoFocus]="true" [autoFocusInOverlay]="true" class="btn btn-primary"
              (click)="callback(true)">{{ confirmText }}
      </button>
    }
  }
</div>
